import React, { useState, useEffect, useRef } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import UploaderComponent from './uploader'
import MatchComponent from './match'
import PreviewComponent from './preview'
import { uploadData } from '../../redux/actions/upload'
import { checkIsPhoneNumberValid, checkIsEmailValid } from '../../services/helper'
import { toast } from '../CommonComponents/ToastComponent/toast'
import CreateOrUpdatePartnerComponent from '../CreateOrUpdatePartnerComponent'
import { MdOutlineArrowBackIosNew } from 'react-icons/md'
import CreateCallingScriptComponent from '../CreateCallingScriptComponent'
import { parsePhoneNumber } from 'awesome-phonenumber'

const UploadComponent = () => {
  const dispatch = useDispatch()
  const store = useStore().getState()
  const history = useHistory()
  const {
    upload: { matchedData },
    app: {
      currentDataSource
    },
    partner: { partnerNames }
  } = store

  const param = window.location.href.split('upload')[1]
  const addressColumns = ['address1', 'address2', 'city', 'state', 'zip', 'country']

  const tabs = [
    {
      label: 'Step 1 : Upload File',
      value: 'upload',
    },
    {
      label: 'Step 2 : Mapping',
      value: 'match',
    },
    {
      label: 'Step 3: Preview & Finish',
      value: 'preview',
    }
  ]

  const dbMatchColumns = [
    {
      name: 'partnerName',
      label: 'Partner Name'
    },
    {
      name: 'companyName',
      label: 'Company name'
    },
    {
      name: 'primaryContact',
      label: 'Primary Contact'
    },
    {
      name: 'contactPhone',
      label: 'Contact Phone'
    },
    {
      name: 'contactEmail',
      label: 'Contact Email'
    },
    {
      name: 'nameUse',
      label: 'Name Use'
    },
    {
      name: 'callingScriptId',
      label: 'Calling Script'
    }
  ]

  const [currentTab, setCurrentTab] = useState('upload')
  const [dbMatchValues, setDbmatchValues] = useState({})
  const [isPhoneValid, setIsPhoneValid] = useState('')
  const [isValidatingPhone, setIsValidatingPhone] = useState(false)
  const [isEmailValid, setIsEmailValid] = useState('')
  const [isValidatingEmail, setIsValidatingEmail] = useState(false)
  const [countryCode, setCountryCode] = useState('')
  const phoneInputRefname = useRef(null);
  const [showPartnerManagement, setShowPartnerManagement] = useState(false)
  const [showCreateCallingScript, setShowCreateCallingScript] = useState(false)
  const [selectedPartner, setSelectedPartner] = useState(null)
  const [defaultScript, setDefaultScript] = useState(null)
  const [selectedSupplierType, setSelectedSupplierType] = useState({})
  const [selectedSupplierOption, setSelectedSupplierOption] = useState({})
  const [originalFile, setOriginalFile] = useState({})
  const [isProcessing, setIsProcessing] = useState(false);
  const [colWithStatus, setColWithStatus] = useState([])
  useEffect(() => {
    const tmpData = {}
    dbMatchColumns.map(col => {
      tmpData[col.name] = col?.name === 'nameUse' ? null : ''
    })
    setDbmatchValues(tmpData)
  }, [])

  useEffect(() => {
    if (!param) {
      handleHideShowPartnerManagement()
    }
  }, [param])

  const handleClickTab = (tab) => {
    if (tab === 'match' && matchedData && matchedData.cols && matchedData.cols.length > 0) { // to not map address columns if full address is mapped
      let isFullAddMapped = matchedData.cols.find((column) => column.matchedName === 'fullAddress')
      if (isFullAddMapped && isFullAddMapped.confirm === 2) {
        matchedData.cols.map((col) => {
          if (addressColumns.includes(col.matchedName)) {
            col.confirm = 1
          }
        })
      }
    }
    setCurrentTab(tab)
  }

  const handleUploadData = (cols, data, fileName, totalRows) => {
    const hasPlaceholder = (value) => {
      const placeholders = ["#", "string", "example@gmail.com", "true/false"];
      return placeholders.some(placeholder => String(value).includes(placeholder));
    };
    const shouldRemoveFirstElement = Object.values(data[0]).some(hasPlaceholder);
    if (shouldRemoveFirstElement) {
      data.shift();
    }

    const CHUNK_SIZE = 50000;  // Manage the chunk size to be displaid and uploaded from preview table
    const tmpData = {};
    dbMatchColumns.map(col => {
      tmpData[col.name] = col?.name === 'nameUse' ? null : '';
    });
    setDbmatchValues(tmpData);
    const chunks = [];
    for (let i = 0; i < data.length; i += CHUNK_SIZE) {
      chunks.push(data.slice(i, i + CHUNK_SIZE));
    }
    processNextChunk(chunks[0], cols, fileName, data.length);
  };

  const processNextChunk = (chunk, cols, fileName, totalRows) => {
    setIsProcessing(true);
  
    dispatch(
      uploadData({
        cols,
        data: chunk,
        fileName,
        totalRows,
        processedRows: chunk.length
      })
    );
    
    setIsProcessing(false);
  };

  const handleDbMatchValuesUpdate = (colName, value) => {
    let tmpValue = value
    if (colName === 'contactEmail') {
      if (!tmpValue) {
        setIsEmailValid(true)
      } else {
        setIsEmailValid('')
      }
    } else if (colName === 'partnerName') {
      let contactNameVal = partnerNames?.find(val => val.partnerName === tmpValue)
      let callingScripts = partnerNames?.find(val => val?.partnerName === tmpValue)?.callingScripts
      let defaultScript = callingScripts?.find(script => script?.isDefault)
      setDefaultScript(defaultScript ? defaultScript : null)
      setDbmatchValues({
        ...dbMatchValues, [colName]: tmpValue, primaryContact: contactNameVal?.contactName || '', callingScriptId: defaultScript ? {
          label: defaultScript?.title,
          value: defaultScript?.id
        } : null
      })
      return
    }
    setDbmatchValues({ ...dbMatchValues, [colName]: tmpValue })
  }

  const handlePhoneNumberFocusOut = async (event, country, phoneValue, isUseEffect = false) => {
    var countryCode = country && country.dialCode
    var phoneValueWithCode = phoneValue
    var phoneNewValue = phoneValue ? '+' + phoneValue : phoneValue
    const phone = parsePhoneNumber(phoneNewValue);
    const isValid = phone?.valid || false
    if (!isValid) {
      setIsPhoneValid(false)
      toast.show({
        title: 'Warning',
        description: 'Please enter valid phone number!'
      })
      return
    }

    if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode.replace(/^\s*(?:\+)/, ''))) {
      return
    }
    if (phoneValue !== '') {
      setIsValidatingPhone(true)
      phoneValue = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
      var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch)
      setIsPhoneValid(phoneValidationResult?.isPhoneValid)
      setIsValidatingPhone(phoneValidationResult?.isValidatingPhone)
    } else {
      setIsPhoneValid(true)
    }
  }

  const handlePhoneInputChange = (value, country, e, formattedValue) => {
    var phoneValue = formattedValue.replace(/^\s*(?:\+?(\d{1,4}))\s?/, '').replace(/[^\w\s]|[\s]/gi, '')
    var countrycode = country.dialCode + ' '
    if (phoneValue !== '') {
      phoneValue = countrycode + phoneValue
      setIsPhoneValid('')
    } else {
      phoneValue = country.dialCode
      setIsPhoneValid(true)
    }
    if (e.target === null) {
      handlePhoneNumberFocusOut(e, country, formattedValue)
    }
    setCountryCode(country.dialCode)
    setDbmatchValues({
      ...dbMatchValues,
      'contactPhone': phoneValue === '' ? '' : phoneValue,
    })
  }

  const handleKeyDown = (e, phoneInputRefname) => {
    if (e.keyCode === 9) {
      phoneInputRefname.current.props.onBlur()
    }
  }

  const handleEmailFocusOut = async (emailValue) => {
    if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
      setIsEmailValid(false)
      toast.show({
        title: 'Warning',
        description: 'Email Address must be in email format!'
      })
      return
    }
    if (emailValue && emailValue !== '') {
      setIsValidatingEmail(true)
      var emailValidationResult = await checkIsEmailValid(emailValue, dispatch)
      setIsEmailValid(emailValidationResult?.isEmailValid)
      setIsValidatingEmail(emailValidationResult?.isValidatingEmail)
    } else {
      setIsEmailValid(true)
    }
  }

  const handleHideShowPartnerManagement = (value) => {
    value === false && history.push('/upload')
    setShowPartnerManagement(value)
  }

  const handleShowCreateCallingScript = (value) => {
    value === false && history.push('/upload')
    let partner = partnerNames.find(val => val.partnerName === dbMatchValues?.partnerName)
    if (value && !partner?.id) {
      toast.show({
        title: 'Warning',
        description: 'Please select partner name!'
      })
      return
    }
    setSelectedPartner(partner)
    setShowCreateCallingScript(value)
  }

  const handleCallWithStatus = (data) => {
    setColWithStatus(data)
  }

  return (
    showPartnerManagement ? (
      <CreateOrUpdatePartnerComponent
        OnHidePartnerManagement={handleHideShowPartnerManagement}
      />
    ) :
      showCreateCallingScript ?
        <CreateCallingScriptComponent
          onShowCreateCallingScript={handleShowCreateCallingScript}
          partnerId={selectedPartner?.id}
          defaultScript={defaultScript}
          partnerName={selectedPartner ? selectedPartner?.partnerName : ''}
        />
        :
        <div className='upload-component'>
          <div className='upload-header'>
            {
              tabs.map((tab, index) => (
                <button
                  type="button"
                  onClick={() => { handleClickTab(tab.value) }}
                  className={`upload-tab d-flex align-items-center ${currentTab === tab.value ? 'selected' : ''}`}
                  key={tab.value}
                >
                  {tab.label}
                  {index === tabs.length - 1 ? '' : <span>{'>'}</span>}
                </button>
              ))
            }
          </div>
          <div className="upload-body">
            {
              currentTab === 'upload' && (
                <UploaderComponent
                  onUploadData={handleUploadData}
                  onContinue={handleClickTab}
                  setOriginalFile={setOriginalFile}
                />
              )
            }
            {
              currentTab === 'match' && (
                <MatchComponent
                  onGoBack={handleClickTab}
                  onContinue={handleClickTab}
                  dbMatchColumns={dbMatchColumns}
                  dbMatchDataValues={dbMatchValues}
                  onChangeDbMatchValues={handleDbMatchValuesUpdate}
                  onEmailFocusOut={handleEmailFocusOut}
                  onKeyDown={handleKeyDown}
                  onPhoneInputChange={handlePhoneInputChange}
                  onPhoneNumberFocusOut={handlePhoneNumberFocusOut}
                  phoneInputRefname={phoneInputRefname}
                  isValidatingPhone={isValidatingPhone}
                  isPhoneValid={isPhoneValid}
                  isValidatingEmail={isValidatingEmail}
                  isEmailValid={isEmailValid}
                  onShowPartnerManagement={handleHideShowPartnerManagement}
                  onShowCreateCallingScript={handleShowCreateCallingScript}
                  setDbmatchValues={setDbmatchValues}
                  setSelectedSupplierType={setSelectedSupplierType}
                  setSelectedSupplierOption={setSelectedSupplierOption}
                  selectedSupplierOption={selectedSupplierOption}
                  onCallWithStatus={handleCallWithStatus}
                />
              )
            }
            {
              currentTab === 'preview' && (
                <PreviewComponent
                  onGoBack={handleClickTab}
                  dbMatchValues={dbMatchValues}
                  selectedSupplierType={selectedSupplierType}
                  originalFile={originalFile}
                  isProcessing={isProcessing}
                  colWithStatus={colWithStatus}
                />
              )
            }
          </div>
        </div>
  )
}

export default UploadComponent
